import { useContext } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { AuthContext } from 'libs.react_internal';
import { AxonAccountContext } from '../../contexts/axon_account';
import { useCurrentEnvironment } from '../use_current_environment';
import { useSiteContext } from '../use_site_context';
export const useLumosEventLogger = () => {
    const { logEvent } = useContext(FirebaseAppContext);
    const { entityId, user } = useContext(AuthContext);
    const { environment } = useCurrentEnvironment();
    const { account } = useContext(AxonAccountContext);
    const site = useSiteContext();
    const logLumosEvent = (eventKey, eventData) => {
        logEvent(eventKey, {
            ...eventData,
            studyId: environment?.studyId,
            environmentId: environment?.id,
            axonUserId: account?._id,
            siteId: site?._id,
            entityId,
            identityId: user?.id,
        });
    };
    return {
        logLumosEvent,
    };
};
